import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const importVenues = async (file: File): Promise<Response> => {
  const formData: FormData = new FormData();
  formData.append('file', file);

  const url = `${API_URL}/venues/import`;
  try {
    const res = await fetch(url, {
      method: 'POST',
      cache: 'reload',
      body: formData,
    });
    if (!res.ok) throw new Error(res.statusText);
    return res;
  } catch (e) {
    throw new Error('Could not import venues', { cause: e });
  }
};
